//- Reducers
const users = (state = null, action) => {
  switch (action) {
    default:
      return state;
  }
};

export default users;
